/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

/* PACKAGES */
import { Helmet } from "react-helmet";
import DataTable from "react-data-table-component";
import {
  Button,
  Dialog,
  DialogBody,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ReactImageUploading from "react-images-uploading";

/* API */
import {
  deleteExpoList,
  getPreBookingDetails,
  getPreBookingList,
  paymentStatusPatch,
  prebookingIdPatch,
} from "service/api";

/* ICONS */
import { IoClose } from "react-icons/io5";
import { HiMenuAlt4 } from "react-icons/hi";
import Input from "components/input";
import { Country } from "country-state-city";
import { toast } from "react-hot-toast";
import { FiUpload } from "react-icons/fi";
import { FaTrash } from "react-icons/fa6";
import { IMAGE_URL } from "config";

const sectorOptions = [
  { value: null, label: "All" },
  {
    value: "Advertising and Social Media",
    label: "Advertising and Social Media",
  },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Auto sector", label: "Auto sector" },
  { value: "Banking and Finance", label: "Banking and Finance" },
  {
    value: "Chemicals, Petrochemicals and Fertilizers",
    label: "Chemicals, Petrochemicals and Fertilizers",
  },
  { value: "Education", label: "Education" },
  { value: "Electrical", label: "Electrical" },
  { value: "Event Management", label: "Event Management" },
  { value: "FMCG Products", label: "FMCG Products" },
  { value: "Food and Farming", label: "Food and Farming" },
  { value: "Furniture", label: "Furniture" },
  { value: "Gems and Jewellery", label: "Gems and Jewellery" },
  { value: "Mining", label: "Mining" },
  { value: "Handicrafts", label: "Handicrafts" },
  { value: "Healthcare", label: "Healthcare" },
  {
    value: "Hospitality, Travel and Tourism",
    label: "Hospitality, Travel and Tourism",
  },
  { value: "Imports and Exports", label: "Imports and Exports" },
  { value: "IT and Digital Media", label: "IT and Digital Media" },
  { value: "Logistics and Shipping", label: "Logistics and Shipping" },
  { value: "Paper and Stationery", label: "Paper and Stationery" },
  { value: "Plastics", label: "Plastics" },
  { value: "Professional services", label: "Professional services" },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Renewable Energy", label: "Renewable Energy" },
  { value: "Sports and Recreation", label: "Sports and Recreation" },
  { value: "Telecom", label: "Telecom" },
  { value: "Textile Industry", label: "Textile Industry" },
  { value: "Turnkey Projects", label: "Turnkey Projects" },
  { value: "Waste Management", label: "Waste Management" },
  { value: "Media and Entertainment", label: "Media and Entertainment" },
  { value: "Security and Defence", label: "Security and Defence" },
];

const stallOptions = [
  { value: "Table Space (1 Side Open)", label: "Table Space (1 Side Open)" },
  { value: "Table Space (2 Side Open)", label: "Table Space (2 Side Open)" },
  {
    value: "Economy Stall (1 Side Open) (4 sqms)",
    label: "Economy Stall (1 Side Open) (4 sqms)",
  },
  {
    value: "Economy Stall (2 Side Open) (4 sqms)",
    label: "Economy Stall (2 Side Open) (4 sqms)",
  },
  {
    value: "Classic Shell Space (1 Side Open) (9 sqms - 18 sqms)",
    label: "Classic Shell Space (1 Side Open) (9 sqms - 18 sqms)",
  },
  {
    value: "Premium Shell Space (2 Sides Open) (9 sqms - 18 sqms)",
    label: "Premium Shell Space (2 Sides Open) (9 sqms - 18 sqms)",
  },
  {
    value: "Premium Shell Space (3 Sides Open) (9 sqms - 18 sqms)",
    label: "Premium Shell Space (3 Sides Open) (9 sqms - 18 sqms)",
  },
  {
    value: "Classic Bare Space (1 Side Open) (18 sqms - 99 sqms)",
    label: "Classic Bare Space (1 Side Open) (18 sqms - 99 sqms)",
  },
  {
    value: "Premium Bare Space (2 Sides Open) (18 sqms - 99 sqms)",
    label: "Premium Bare Space (2 Sides Open) (18 sqms - 99 sqms)",
  },
  {
    value: "Premium Bare Space (3 Sides Open) (18 sqms - 99 sqms)",
    label: "Premium Bare Space (3 Sides Open) (18 sqms - 99 sqms)",
  },
  {
    value: "Island (4 Sides Open) (48 sqms & 99 sqms)",
    label: "Island (4 Sides Open) (48 sqms & 99 sqms)",
  },
];

const PrebookingLeads = () => {
  /* LOADING STATE */
  const [loading, setLoading] = useState(false);

  /* ACTIVE STEP */
  const [activeStep, setActiveStep] = useState(1);

  /* PAGINATION */
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);

  /* LEADS FORM */
  const [expoLeads, setExpoLeads] = useState([]);
  const [leadDetails, setLeadDetails] = useState();
  const [totalDocs, setTotalDocs] = useState([]);

  /* DIALOG */
  const [viewDialog, setViewDialog] = useState(false);
  const [pricing, setPricing] = useState();
  const [currency, setCurrency] = useState();

  /* EDIT DIALOG */
  const [editDialog, setEditDialog] = useState(false);

  /* PAYMENT STATUS */
  const [paymentStatus, setPaymentStatus] = useState({
    value: "All",
    label: "All",
  });

  /* NAME FILTER */
  const [name, setName] = useState("");
  const [debouncedName, setDebouncedName] = useState("");

  /* COUNTRY FILTER */
  const [countryOptions, setCountryOptions] = useState([]);
  const [country, setCountry] = useState(null);

  /* STATE FILTER */
  const [state, setState] = useState("");
  const [debouncedState, setDebouncedState] = useState("");

  /* SECTOR */
  const [sector, setSector] = useState(null);

  /* EXPORT DATA */
  const [exportLoading, setExportLoading] = useState(false);

  /* STATUS DIALOG */
  const [statusDialog, setStatusDialog] = useState(false);

  /* SELECTED STATUS */
  const [selectedStatus, setSelectedStatus] = useState(null);

  /* TRANSACTION ID */
  const [transactionId, setTransactionId] = useState("");

  /* TRANSACTION DATE */
  const [transactionDate, setTransactionDate] = useState(null);

  /* CURRENCY */
  const [selectedCurrency, setSelectedCurrency] = useState();

  /* AMOUNT */
  const [currencyAmount, setCurrencyAmount] = useState();

  /* PAYMENT REMARK */
  const [paymentRemark, setPaymentRemark] = useState("");

  /* STATUS LOADING */
  const [statusLoading, setStatusLoading] = useState(false);

  /* VIEW PAYMENT STATUS */
  const [paymentStatusDialog, setPaymentStatusDialog] = useState(false);

  /* PAYMENT SCREENSHOT */
  const [paymentScreenshot, setPaymentScreenshot] = useState();

  /* DELETE DIALOG */
  const [deleteDialog, setDeleteDialog] = useState(false);

  /* DELETE LOADING */
  const [deleteLoading, setDeleteLoading] = useState(false);

  /* EDIT STATES */
  const [editLoading, setEditLoading] = useState(false);
  const [editSaving, setEditSaving] = useState(false);
  const [originalLeadDetails, setOriginalLeadDetails] = useState(null);

  /* EDIT INVOICE ID STATE */
  const [invoiceDialog, setInvoiceDialog] = useState(false);

  /* EDIT INVOICE ID */
  const [selectedInvoiceId, setSelectedInvoiceId] = useState();

  /* EDIT INVOICE LOADING */
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  /* EDIT STALL SIZE DIALOG */
  const [editStallSizeDialog, setEditStallSizeDialog] = useState(false);
  const [updatedCategory, setUpdatedCategory] = useState(null);
  const [updatedStallSize, setUpdatedStallSize] = useState(null);
  const [stallSizeLoading, setStallSizeLoading] = useState(false);

  /* GET EXPO LEADS */
  const getExpoLeads = (status = paymentStatus?.value) => {
    setLoading(true);
    const params = {
      page: page,
      sizePerPage: sizePerPage,
      pagination: true,
    };

    if (debouncedName !== "") {
      params.name = debouncedName;
    }

    if (country !== null) {
      params.country = country?.value;
    }

    if (debouncedState !== "") {
      params.city = debouncedState;
    }

    if (sector !== null) {
      params.sectors = sector?.value;
    }

    if (paymentStatus?.value !== "All") {
      params.paymentStatus = paymentStatus?.value;
    }

    getPreBookingList(params)
      .then((res) => {
        setExpoLeads(res?.data?.docs);
        setTotalDocs(res?.data?.totalDocs);
        console.log(
          "%c Line:74 🍣 res?.docs",
          "color:#ea7e5c",
          res?.data?.docs
        );
      })
      .catch((e) => {
        console.log("Error:", e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  /* EDIT HANDLER */
  const handleEditDialogOpen = async (lead) => {
    setActiveStep(1);
    setEditDialog(true);
    setEditLoading(true);
    setLeadDetails(lead);
    setOriginalLeadDetails(lead ? JSON.parse(JSON.stringify(lead)) : null);
    setPricing(lead?.pricing);
    setCurrency(lead?.currency);

    try {
      if (!lead?._id) {
        return;
      }
      const response = await getPreBookingDetails(lead._id);
      const leadData =
        response?.data?.data ?? response?.data ?? response ?? null;
      if (leadData) {
        const deepClonedLead = JSON.parse(JSON.stringify(leadData));
        setLeadDetails(deepClonedLead);
        setOriginalLeadDetails(JSON.parse(JSON.stringify(leadData)));
        setPricing(leadData?.pricing);
        setCurrency(leadData?.currency);
      }
    } catch (error) {
      console.error("Error fetching form details:", error);
      toast.error("Failed to load form details");
    } finally {
      setEditLoading(false);
    }
  };

  const closeEditDialog = () => {
    setEditDialog(false);
    setActiveStep(1);
    setEditLoading(false);
    setEditSaving(false);
    setOriginalLeadDetails(null);
    setLeadDetails(null);
  };

  /* SAVE EDITED FORM */
  const editFormHandler = async () => {
    if (!leadDetails?._id) {
      toast.error("Form details are unavailable");
      return;
    }

    const changes = {};
    const trimmedStallCategory = leadDetails?.stallCategory
      ? leadDetails.stallCategory.trim()
      : "";
    const trimmedStallSize = leadDetails?.stallSize
      ? leadDetails.stallSize.trim()
      : "";
    const originalStallCategory = originalLeadDetails?.stallCategory
      ? originalLeadDetails.stallCategory.trim()
      : "";
    const originalStallSize = originalLeadDetails?.stallSize
      ? originalLeadDetails.stallSize.trim()
      : "";

    if (trimmedStallCategory !== originalStallCategory) {
      changes.stallCategory = trimmedStallCategory;
    }

    if (trimmedStallSize !== originalStallSize) {
      changes.stallSize = trimmedStallSize;
    }

    if (Object.keys(changes).length === 0) {
      toast.info("No changes to save.");
      return;
    }

    setEditSaving(true);
    try {
      await paymentStatusPatch(leadDetails._id, changes);
      toast.success("Form updated successfully");
      setOriginalLeadDetails((prev) =>
        prev ? { ...prev, ...changes } : { ...leadDetails, ...changes }
      );
      setLeadDetails((prev) => (prev ? { ...prev, ...changes } : prev));
      closeEditDialog();
      getExpoLeads();
    } catch (error) {
      console.error("Error updating form:", error);
      toast.error("Failed to update form");
    } finally {
      setEditSaving(false);
    }
  };

  /* EXPORT LEADS FUNCTION */
  const fetchAllLeads = async () => {
    try {
      const params = {
        pagination: false,
      };

      if (debouncedName) params.name = debouncedName;
      if (country) params.country = country?.value;
      if (debouncedState) params.city = debouncedState;
      if (sector) params.sectors = sector?.value;

      const res = await getPreBookingList(params);
      return res?.data;
    } catch (error) {
      console.error("Error exporting leads:", error);
      return [];
    }
  };

  /* EXCEL EXPORT BUTTON */
  const ExcelExportButton = () => {
    const handleExport = async () => {
      setExportLoading(true);
      const allLeads = await fetchAllLeads();
      setExportLoading(false);

      if (!allLeads.length) return;

      console.log("allLeads", allLeads);

      const formattedData = allLeads.map((lead, index) => ({
        "Sr. No": index + 1,
        "Profile Image": `https://storage.googleapis.com/kidsstreet-test/${lead?.profileImage}`,
        "First name": lead?.firstName || "-",
        "Last name": lead?.lastName || "-",
        "Pre Booking ID": lead?.preBookingId || "-",
        "Email address": lead?.email || "-",
        "Phone number": lead?.phoneNumber || "-",
        "Business Name": lead?.businessName || "-",
        "Billing Name": lead?.billingName || "-",
        "Business Logo": `https://storage.googleapis.com/kidsstreet-test/${lead?.businessLogo}`,
        "Business Description": lead?.briefBusinessDescription || "-",
        "Business Address": `${lead.businessAddressDetails.address}, ${lead.businessAddressDetails.city}, ${lead.businessAddressDetails.state}, ${lead.businessAddressDetails.postalCode}, ${lead.businessAddressDetails.country}`,
        "Billing Address": `${lead.billingAddressDetails.address}, ${lead.billingAddressDetails.city}, ${lead.billingAddressDetails.state}, ${lead.billingAddressDetails.postalCode}, ${lead.billingAddressDetails.country}`,
        "GST Number": lead?.gstNumber || "-",
        "PAN Number": lead?.panNumber || "-",
        Industries: Array.isArray(lead?.industry)
          ? lead?.industry.join(", ")
          : "-",
        "Areas of exploration": Array.isArray(lead?.areasOfExploration)
          ? lead?.areasOfExploration.join(", ")
          : "-",
        "Areas of operation": Array.isArray(lead?.areasOfOperation)
          ? lead?.areasOfOperation.join(", ")
          : "-",
        "Interested in sponsorship": lead?.isInterestedInSponsorship
          ? "Yes"
          : "No" || "-",
        "Amount paid": lead?.payAmount || "-",
        "Stall category": lead?.stallCategory || "-",
        "Stall size": lead?.stallSize || "-",
        "Payment status": lead?.paymentStatus,
        "Payment currency": lead?.remarkCurrency || "-",
        //"Remark amount": lead?.remarkAmount || "-",
        "Balance amount": lead?.balanceAmount || "-",
        "Payment Date": new Date(lead?.paymentDate).toLocaleDateString(),
        "Created Date": new Date(lead?.createdAt).toLocaleDateString(),
        "Created Time": new Date(lead?.createdAt).toLocaleTimeString(),
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Prebooking_Leads.xlsx");
    };

    return (
      <button
        onClick={handleExport}
        disabled={exportLoading}
        className="bg-logoYellow text-white text-sm font-ibm-semibold px-4 py-3 rounded-md hover:bg-logoYellow/80 transition"
      >
        {exportLoading ? "Exporting..." : "Export All Data"}
      </button>
    );
  };

  /* FUNCTIONS */
  const handlePageChange = async (e) => {
    setPage(e);
  };

  const handlePerPageChange = async (e) => {
    setSizePerPage(e);
    setPage(1);
  };

  /* USE EFFECT */
  useEffect(() => {
    const searchByNameDebounce = setTimeout(() => {
      setDebouncedName(name);
      setDebouncedState(state);
    }, 2000);
    return () => clearTimeout(searchByNameDebounce);
  }, [name, state]);

  /* USE EFFECT */
  useEffect(() => {
    getExpoLeads(paymentStatus?.value);
  }, [
    page,
    sizePerPage,
    paymentStatus,
    debouncedName,
    country,
    debouncedState,
    sector,
  ]);

  /* LOADING SCREEN FOR DATATABLE */
  const LoadingScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-ibm-semibold text-black text-center">
          Please wait!
        </p>
        <p className="text-sm font-ibm-semibold text-black text-center">
          We are fetching data{" "}
        </p>
      </div>
    );
  };

  /* NO DATA SCREEN */
  const NoDataScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-ibm-semibold text-black text-center">
          There are no queries to display.
        </p>
      </div>
    );
  };

  /* COLUMNS */
  const columns = [
    {
      name: "Sr. No",
      grow: 0.3,
      selector: (row, index) => (
        <span className="text-sm font-ibm-semibold text-black text-opacity-60">
          {(page - 1) * sizePerPage + index + 1}
        </span>
      ),
    },
    {
      name: "Booking ID",
      grow: 0.8,
      selector: (row) => (
        <span className="text-sm font-ibm-semibold text-black text-opacity-60">
          {row?.preBookingId === undefined ? "-" : row?.preBookingId}
        </span>
      ),
    },
    {
      name: "Name",
      grow: 1.5,
      selector: (row) => (
        <div className="max-w-30 pr-5">
          <p
            style={{ overflowWrap: "anywhere", textWrap: "auto" }}
            className="text-base font-ibm-semibold text-black"
          >
            {row.firstName} {row?.lastName}
          </p>
          <p
            style={{ overflowWrap: "anywhere", textWrap: "auto" }}
            className="block text-sm mt-1 font-ibm-regular text-greyText hover:text-logoYellow transition-all duration-300 ease-in-out"
          >
            {row.businessName}
          </p>
        </div>
      ),
    },
    {
      name: "Email & Phone",
      grow: 1.5,
      selector: (row) => (
        <>
          <a
            href={`mailto:${row.email}`}
            className="block text-sm font-ibm-regular text-blue-500 transition-all duration-300 ease-in-out"
          >
            {row.email}
          </a>
          <a
            href={`tel:${row.phoneNumber}`}
            className="mt-2 block text-sm font-ibm-regular text-blue-500 transition-all duration-300 ease-in-out"
          >
            {row.phoneNumber}
          </a>
        </>
      ),
    },
    {
      name: "Stall size",
      grow: 1.5,
      selector: (row) => (
        <>
          <p className="block text-sm font-ibm-regular text-greyText transition-all duration-300 ease-in-out">
            {row.stallCategory}
          </p>
          <p className="mt-1.5 block text-sm font-ibm-regular text-greyText transition-all duration-300 ease-in-out">
            {row.stallSize}
          </p>
        </>
      ),
    },
    {
      name: "Payment Status",
      grow: 1,
      selector: (row) => (
        <>
          <p
            className={`text-sm font-ibm-semibold pr-10 ${
              row?.paymentStatus === "Pre-booking amount paid"
                ? "text-orange-500"
                : row?.paymentStatus === "pending"
                ? "text-red-500"
                : "text-green-500"
            } leading-relaxed`}
          >
            {row?.paymentStatus === "success"
              ? "Paid"
              : row?.paymentStatus === "pending"
              ? "Unpaid"
              : row?.paymentStatus === "Pre-booking amount paid"
              ? "Booking amount paid"
              : row?.paymentStatus === "Balance amount paid"
              ? "Full amount paid"
              : "Full amount paid"}
          </p>
        </>
      ),
    },
    {
      name: "Date & Time",
      selector: (row) => (
        <>
          <p className="text-sm font-ibm-regular text-greyText">
            {new Date(row.createdAt).toLocaleDateString("en-gb", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
          <p className="mt-1 text-sm font-ibm-regular text-greyText">
            {new Date(row.createdAt).toLocaleTimeString("en-gb", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })}
          </p>
        </>
      ),
    },
    {
      name: "Actions",
      grow: 0.5,
      selector: (row) => (
        <Menu>
          <MenuHandler>
            <Button className="shadow-none hover:shadow-none bg-white rounded-full p-2 border border-authBorder">
              <HiMenuAlt4 className="w-5 h-5 text-black" />
            </Button>
          </MenuHandler>
          <MenuList className="p-2 !min-w-[20vh]">
            <MenuItem>
              <div
                onClick={() => {
                  setLeadDetails(row);
                  setViewDialog(!viewDialog);
                  setPricing(row?.pricing);
                  setCurrency(row?.currency);
                }}
                className="block text-sm font-ibm-regular text-black cursor-pointer"
              >
                View details
              </div>
            </MenuItem>
            {(row?.remarkAmount || row?.balanceAmount) && (
              <MenuItem>
                <div
                  onClick={() => {
                    setPaymentStatusDialog(!paymentStatusDialog);
                    setLeadDetails(row);
                  }}
                  className="block text-sm font-ibm-regular text-black cursor-pointer"
                >
                  View payment details
                </div>
              </MenuItem>
            )}
            <MenuItem>
              <div
                onClick={() => {
                  setEditStallSizeDialog(!editStallSizeDialog);
                  setLeadDetails(row);
                  setUpdatedStallSize(row?.stallSize);
                }}
                className="block text-sm font-ibm-regular text-black cursor-pointer"
              >
                Edit stall size/category
              </div>
            </MenuItem>
            {row?.paymentStatus !== "pending" && (
              <MenuItem>
                <div
                  onClick={() => {
                    setInvoiceDialog(!invoiceDialog);
                    setSelectedInvoiceId(row?.preBookingId);
                  }}
                  className="block text-sm font-ibm-regular text-black cursor-pointer"
                >
                  Edit booking id/invoice id
                </div>
              </MenuItem>
            )}
            <MenuItem>
              <div
                onClick={() => {
                  setStatusDialog(!statusDialog);
                  setLeadDetails(row);
                  if (row.remarkAmount) {
                    setSelectedStatus({
                      value: row.paymentStatus,
                      label: row.paymentStatus,
                    });
                    setPaymentRemark(row.paymentRemark);
                    setTransactionId(row.transactionId);
                    setSelectedCurrency({
                      value: row.remarkCurrency,
                      label: row.remarkCurrency,
                    });
                    setCurrencyAmount(row.remarkAmount);
                  }
                }}
                className="block text-sm font-ibm-regular text-black cursor-pointer"
              >
                Edit payment status
              </div>
            </MenuItem>
            {row?.paymentStatus !== "pending" && (
              <MenuItem>
                <a
                  href={"https://libf.co/invoice/" + row?._id}
                  target="_blank"
                  rel="noreferrer"
                  className="block text-sm font-ibm-regular text-black"
                >
                  Download pre-booking invoice
                </a>
              </MenuItem>
            )}
            {row?.paymentStatus !== "pending" &&
              row?.balanceAmount &&
              row?.paymentStatus === "Pre-booking amount paid" && (
                <MenuItem>
                  <a
                    href={"https://libf.co/balance-invoice/" + row?._id}
                    target="_blank"
                    rel="noreferrer"
                    className="block text-sm font-ibm-regular text-black"
                  >
                    Download balance payment invoice
                  </a>
                </MenuItem>
              )}
            {row?.paymentStatus !== "pending" &&
              row?.balanceAmount &&
              row?.paymentStatus === "Full amount paid" && (
                <MenuItem>
                  <a
                    href={"https://libf.co/balance-invoice/" + row?._id}
                    target="_blank"
                    rel="noreferrer"
                    className="block text-sm font-ibm-regular text-black"
                  >
                    Download full payment invoice
                  </a>
                </MenuItem>
              )}
            <MenuItem
              onClick={() => {
                setDeleteDialog(!deleteDialog);
                setLeadDetails(row);
              }}
              className="block text-sm font-ibm-regular text-red-400 cursor-pointer"
            >
              Delete entry
            </MenuItem>
          </MenuList>
        </Menu>
      ),
    },
  ];

  /* UPDATE FUNCTION */
  const updateStatusAPI = async () => {
    setStatusLoading(true);

    /* FORMDATA */
    const formData = new FormData();

    if (selectedStatus) {
      formData.append("paymentStatus", selectedStatus?.value);
    }

    if (paymentRemark) {
      formData.append("paymentRemark", paymentRemark);
    }

    if (transactionId) {
      formData.append("transactionId", transactionId);
    }

    if (selectedCurrency) {
      formData.append("remarkCurrency", selectedCurrency?.value);
    }

    if (
      selectedStatus?.value === "Balance amount paid" ||
      selectedStatus?.value === "Full amount paid"
    ) {
      formData.append("balanceAmount", currencyAmount);
    } else if (currencyAmount) {
      formData.append("remarkAmount", currencyAmount);
    }

    if (transactionDate) {
      formData.append("transactionDate", transactionDate);
    }

    if (paymentScreenshot && paymentScreenshot[0]?.file) {
      formData.append("remarkImage", paymentScreenshot[0]?.file);
    }

    try {
      await paymentStatusPatch(leadDetails?._id, formData);
      toast.success("Status updated successfully");
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setStatusLoading(false);
      setStatusDialog(false);
      setPaymentRemark("");
      setCurrencyAmount(null);
      setSelectedCurrency(null);
      setTransactionId("");
      setTransactionDate(null);
      getExpoLeads();
    }
  };

  /* UPDATE BOOKING ID */
  const updateBookingId = async () => {
    setInvoiceLoading(true);

    try {
      await prebookingIdPatch(leadDetails?._id, {
        preBookingId: selectedInvoiceId,
      });
      toast.success("Booking ID/Invoice ID has been updated successfully");
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setInvoiceLoading(false);
      setInvoiceDialog(false);
      getExpoLeads();
    }
  };

  /* UPDATE STALL CATEGORY */
  const updateStallCategoryFn = async () => {
    setStallSizeLoading(true);

    const formData = new FormData();

    if (updatedCategory) {
      formData.append("stallCategory", updatedCategory?.value);
    }

    formData.append("stallSize", updatedStallSize);

    try {
      await paymentStatusPatch(leadDetails?._id, formData);
      toast.success("Stall category has been updated successfully");
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setStallSizeLoading(false);
      setEditStallSizeDialog(!editStallSizeDialog);
      setUpdatedCategory(null);
      setUpdatedStallSize(null);
      getExpoLeads();
    }
  };

  /* DELETE FUNCTION */
  const deleteFormAPI = async () => {
    setDeleteLoading(true);

    try {
      await deleteExpoList(leadDetails?._id);
      toast.success("Form deleted successfully");
    } catch (error) {
      console.error("Error deleting form:", error);
    } finally {
      setDeleteLoading(false);
      setDeleteDialog(false);
      getExpoLeads();
    }
  };

  /* USE EFFECT */
  useEffect(() => {
    const countries = Country.getAllCountries();
    const formattedCountries = countries.map((country) => ({
      value: country.name,
      label: country.name,
    }));
    const optionsWithClear = [
      { value: null, label: "Clear filter" },
      ...formattedCountries,
    ];
    setCountryOptions(optionsWithClear);
  }, []);

  return (
    <section className="p-2 xl:p-5 lg:p-5 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Expo Queries | LIBF</title>
      </Helmet>

      <div className="container-full-width">
        {/* HEADING */}
        <div className="block xl:flex lg:flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-ibm-bold text-black tracking-tight">
              LIBF 2026 Booking Queries
            </h1>
            <h2 className="text-base font-ibm-regular text-greyText">
              Manage the booking forms filled by your visitors on your website.
            </h2>
          </div>
          <ExcelExportButton />
        </div>

        {/* FILTERS */}
        <div className="mt-5 flex items-center justify-end gap-3">
          {/* FILTER BY SECTOR */}
          <div className="w-full xl:w-[25vh] lg:w-[25vh] flex-shrink-0 mt-2 xl:mt-0 lg:mt-0">
            <Select
              options={sectorOptions}
              className="react-select font-proxima-regular"
              classNamePrefix="dropdown"
              placeholder="Filter by sector"
              name="paymentStatus"
              value={sector}
              onChange={(e) => setSector(e)}
            />
          </div>

          {/* FILTER BY TYPE */}
          <div className="w-full xl:w-[25vh] lg:w-[25vh] flex-shrink-0 mt-2 xl:mt-0 lg:mt-0">
            <Select
              options={[
                { value: "All", label: "All" },
                { label: "Unpaid", value: "pending" },
                {
                  label: "Pre-booking amount paid",
                  value: "Pre-booking amount paid",
                },
                { label: "Balance amount paid", value: "Balance amount paid" },
                { label: "Full amount paid", value: "Full amount paid" },
              ]}
              className="react-select font-proxima-regular"
              classNamePrefix="dropdown"
              placeholder="Status"
              name="paymentStatus"
              value={paymentStatus}
              onChange={(e) => setPaymentStatus(e)}
            />
          </div>

          {/* SEARCH BY STATE */}
          <div className="w-full xl:w-[25vh] lg:w-[25vh] mt-2 xl:mt-0 lg:mt-0">
            <Input
              type="text"
              placeholder="Search by city"
              name="state"
              id="state"
              value={state}
              onChange={(e) => setState(e?.target?.value)}
            />
          </div>

          {/* SEARCH BY COUNTRY */}
          <div className="w-full xl:w-[22vh] lg:w-[22vh] mt-2 xl:mt-0 lg:mt-0">
            <Select
              options={countryOptions}
              className="react-select font-proxima-regular"
              classNamePrefix="dropdown"
              placeholder="Filter by country"
              name="country"
              value={country}
              onChange={(e) => setCountry(e)}
            />
          </div>

          {/* SEARCH BY NAME */}
          <div className="w-full xl:w-[25vh] lg:w-[25vh] mt-2 xl:mt-0 lg:mt-0">
            <Input
              type="text"
              placeholder="Search by name"
              name="name"
              id="name"
              value={name}
              onChange={(e) => setName(e?.target?.value)}
            />
          </div>
        </div>

        {/* DATATABLE */}
        <div className="mt-5">
          <DataTable
            className="data-table"
            columns={columns}
            data={expoLeads}
            progressPending={loading}
            progressComponent={<LoadingScreen />}
            pagination
            paginationServer
            paginationTotalRows={totalDocs}
            onChangeRowsPerPage={handlePerPageChange}
            onChangePage={handlePageChange}
            noDataComponent={<NoDataScreen />}
          />
        </div>
      </div>

      {/* EDIT DIALOG */}
      <Dialog
        open={editDialog}
        handler={closeEditDialog}
        size="lg"
        className="outline-none"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-authBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-base font-ibm-semibold text-black">
                {activeStep === 1 && "Personal Details"}
                {activeStep === 2 && "Business Details"}
                {activeStep === 3 && "Payment Details"}
              </h5>
              <Button
                onClick={closeEditDialog}
                className="shadow-none hover:shadow-none bg-transparent hover:bg-black/10 transition-all duration-300 ease-in-out rounded-full p-1.5"
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5 border-b border-authBorder">
            {/* STEP ONE */}
            {activeStep === 1 && (
              <div className="p-0">
                {/* FIRST ROW */}
                <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                  {/* PROFILE PHOTO */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Profile photo <span className="text-red-400">*</span>
                    </label>
                    <div className="mt-1">
                      <img
                        src={`https://storage.googleapis.com/kidsstreet-test/${leadDetails?.profileImage}`}
                        className="w-20 h-20 rounded-lg object-cover"
                        alt="Profile"
                      />
                    </div>
                  </div>

                  {/* FIRST NAME */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="firstName"
                    >
                      First name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        placeholder="First name"
                        disabled
                        value={leadDetails?.firstName}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* LAST NAME */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="lastName"
                    >
                      Last name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="lastName"
                        id="lastName"
                        placeholder="Last name"
                        disabled
                        value={leadDetails?.lastName}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* SECOND ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* GENDER */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Gender
                    </label>
                    <div className="mt-1 flex items-center gap-3">
                      {["Male", "Female", "Others"].map((data, index) => {
                        return (
                          <div
                            className={`w-full px-5 py-3 shadow-none hover:shadow-none rounded-md font-ibm-semibold text-sm text-center  ${
                              leadDetails?.gender === data
                                ? "bg-logoYellow border-logoYellow text-white"
                                : "bg-white border-greyBorder text-black"
                            } border hover:bg-opacity-80 normal-case`}
                            key={index}
                          >
                            {data}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* DATE OF BIRTH */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Date of birth <span className="text-red-400">*</span>
                    </label>
                    <div className="mt-1">
                      <DatePicker
                        selected={leadDetails?.dob}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Date of birth"
                        className="w-full text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* THIRD ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* EMAIL */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="email"
                    >
                      Email <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="email"
                        id="email"
                        placeholder="Email"
                        disabled
                        value={leadDetails?.email}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* PHONE */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="contact"
                    >
                      Phone <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="phoneNumber"
                        id="phoneNumber"
                        placeholder="Phone"
                        disabled
                        value={leadDetails?.phoneNumber}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* FOURTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
                  {/* ADDRESS */}
                  <div className="col-span-4">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="address"
                    >
                      Address <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="address"
                        id="address"
                        placeholder="Address"
                        disabled
                        value={leadDetails?.personalAddressDetails?.address}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* COUNTRY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="country"
                    >
                      Country <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="country"
                        id="country"
                        placeholder="Country"
                        disabled
                        value={leadDetails?.personalAddressDetails?.country}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* STATE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="state"
                    >
                      State <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="state"
                        id="state"
                        placeholder="State"
                        disabled
                        value={leadDetails?.personalAddressDetails?.state}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* CITY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="state"
                    >
                      City <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="city"
                        id="city"
                        placeholder="City"
                        disabled
                        value={leadDetails?.personalAddressDetails?.city}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* POSTAL CODE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="postalCode"
                    >
                      Postal code <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="postalCode"
                        id="postalCode"
                        placeholder="Postal code"
                        disabled
                        value={leadDetails?.personalAddressDetails?.postalCode}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* FIFTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* EDUCATIONAL QUALIFICATIONS */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="education"
                    >
                      Educational Qualifications{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="educationQualification"
                        id="educationQualification"
                        placeholder="Education Qualification"
                        disabled
                        value={leadDetails?.educationQualification}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* OCCUPATION */}
                  <div className="-mt-1 col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="occupation"
                    >
                      Occupation <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="occupation"
                        id="occupation"
                        placeholder="Occupation"
                        disabled
                        value={leadDetails?.occupation}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* BELONG TO LOHANA COMMUNITY */}
                <div className="mt-5 block xl:flex lg:flex items-center gap-5">
                  <p className="text-sm font-ibm-regular text-greyText">
                    Do you belong to the Lohana community?
                  </p>
                  <div className="mt-1 flex items-center gap-3">
                    <div
                      className={`w-full px-5 py-2 shadow-none hover:shadow-none rounded-md font-ibm-semibold text-sm  ${
                        leadDetails?.belongToLohana === true
                          ? "bg-logoYellow border-logoYellow text-white"
                          : "bg-white border-greyBorder text-black"
                      } border hover:bg-opacity-80 normal-case`}
                    >
                      Yes
                    </div>
                    <div
                      className={`w-full px-5 py-2 shadow-none hover:shadow-none rounded-md font-ibm-semibold text-sm  ${
                        leadDetails?.belongToLohana === false
                          ? "bg-logoYellow border-logoYellow text-white"
                          : "bg-white border-greyBorder text-black"
                      } border hover:bg-opacity-80 normal-case`}
                    >
                      No
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* STEP TWO */}
            {activeStep === 2 && (
              <div className="p-0 max-h-[65vh] overflow-auto">
                {/* FIRST ROW */}
                <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                  {/* BUSINESS LOGO */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Business Logo <span className="text-red-400">*</span>
                    </label>
                    <div className="mt-1">
                      <img
                        src={`https://storage.googleapis.com/kidsstreet-test/${leadDetails?.businessLogo}`}
                        className="w-20 h-20 rounded-lg object-cover"
                        alt="Business logo"
                      />
                    </div>
                  </div>

                  {/* BUSINESS NAME */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="businessName"
                    >
                      Business name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessName"
                        id="businessName"
                        placeholder="Business name"
                        disabled
                        value={leadDetails?.businessName}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* BILLING NAME */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="billingName"
                    >
                      Billing name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingName"
                        id="billingName"
                        placeholder="Billing name"
                        disabled
                        value={leadDetails?.billingName}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* SECOND ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                  {/* BUSINESS EMAIL ADDRESS */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="businessEmail"
                    >
                      Business email address{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessName"
                        id="businessName"
                        placeholder="Business name"
                        disabled
                        value={leadDetails?.businessEmail}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* BUSINESS PHONE */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="businessPhone"
                    >
                      Business phone number{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessPhoneNumber"
                        id="businessPhoneNumber"
                        placeholder="Business phone number"
                        disabled
                        value={leadDetails?.businessPhoneNumber}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* WEBSITE URL */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="website"
                    >
                      Website URL
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="website"
                        id="website"
                        placeholder="Website URL"
                        disabled
                        value={leadDetails?.websiteUrl}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* THIRD ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
                  {/* ADDRESS */}
                  <div className="col-span-4">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="businessAddress"
                    >
                      Address <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="address"
                        id="address"
                        placeholder="Business name"
                        disabled
                        value={leadDetails?.businessAddressDetails?.address}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* COUNTRY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="businessCountry"
                    >
                      Country <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="country"
                        id="country"
                        placeholder="Country"
                        disabled
                        value={leadDetails?.businessAddressDetails?.country}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* STATE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="businessState"
                    >
                      State <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessState"
                        id="businessState"
                        placeholder="Business state"
                        disabled
                        value={leadDetails?.businessAddressDetails?.state}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* CITY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="businessCity"
                    >
                      City <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessCity"
                        id="businessCity"
                        placeholder="Business city"
                        disabled
                        value={leadDetails?.businessAddressDetails?.city}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* POSTAL CODE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="businessPostalCode"
                    >
                      Postal code <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessPostalCode"
                        id="businessPostalCode"
                        placeholder="Business postal code"
                        disabled
                        value={leadDetails?.businessAddressDetails?.postalCode}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* FOURTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
                  {/* ADDRESS */}
                  <div className="col-span-4">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="billingAddress"
                    >
                      Billing address <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingAddress"
                        id="billingAddress"
                        placeholder="Billing address"
                        disabled
                        value={leadDetails?.billingAddressDetails?.address}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* COUNTRY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="billingCountry"
                    >
                      Country <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingCountry"
                        id="billingCountry"
                        placeholder="Billing country"
                        disabled
                        value={leadDetails?.billingAddressDetails?.country}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* STATE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="billingState"
                    >
                      State <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingState"
                        id="billingState"
                        placeholder="Billing state"
                        disabled
                        value={leadDetails?.billingAddressDetails?.state}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* CITY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="billingCity"
                    >
                      City <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingCity"
                        id="billingCity"
                        placeholder="Billing city"
                        disabled
                        value={leadDetails?.billingAddressDetails?.city}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* POSTAL CODE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="billingPostalCode"
                    >
                      Postal code <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingPostalCode"
                        id="billingPostalCode"
                        placeholder="Billing postal code"
                        disabled
                        value={leadDetails?.billingAddressDetails?.postalCode}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* FIFTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* GST NUMBER */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="gstNumber"
                    >
                      GST Number <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="gstNumber"
                        id="gstNumber"
                        placeholder="GST Number"
                        disabled
                        value={leadDetails?.gstNumber ?? "-"}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* PAN NUMBER */}
                  <div className="col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="panNumber"
                    >
                      PAN Number <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="panNumber"
                        id="panNumber"
                        placeholder="PAN Number"
                        disabled
                        value={leadDetails?.panNumber ?? "-"}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* SIXTH ROW */}
                <div className="mt-5">
                  <label
                    className="block text-greyText text-sm font-ibm-regular"
                    htmlFor="industry"
                  >
                    Industry / Sectors <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-2 flex items-center gap-2 flex-wrap">
                    {leadDetails?.industry?.map((data, index) => {
                      return (
                        <div
                          className="bg-logoYellow/5 border border-logoYellow rounded-md px-4 py-2 text-sm font-ibm-semibold text-logoYellow"
                          key={index}
                        >
                          {data}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* SEVENTH ROW */}
                <div className="mt-5">
                  {/* BRIEF INTRODUCTION */}
                  <label
                    className="block text-greyText text-sm font-ibm-regular"
                    htmlFor="briefIntroduction"
                  >
                    Give a brief introduction about your business{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-2">
                    <textarea
                      rows="2"
                      disabled
                      name="briefIntroduction"
                      id="briefIntroduction"
                      placeholder="Give a brief introduction about your business"
                      value={leadDetails?.briefBusinessDescription}
                      className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                    />
                  </div>
                </div>

                {/* EIGTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* AREAS OF OPERATION */}
                  <div className="col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="areasOperation"
                    >
                      Geographical areas of operation{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-2 flex items-center gap-2 flex-wrap">
                      {leadDetails?.areasOfOperation?.map((data, index) => {
                        return (
                          <div
                            className="bg-logoYellow/5 border border-logoYellow rounded-md px-4 py-2 text-sm font-ibm-semibold text-logoYellow"
                            key={index}
                          >
                            {data}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* AREAS OF OPERATION WISHING TO EXPLORE */}
                  <div className="col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="areasWishing"
                    >
                      Geographical areas wishing to explore{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-2 flex items-center gap-2 flex-wrap">
                      {leadDetails?.areasOfExploration?.map((data, index) => {
                        return (
                          <div
                            className="bg-logoYellow/5 border border-logoYellow rounded-md px-4 py-2 text-sm font-ibm-semibold text-logoYellow"
                            key={index}
                          >
                            {data}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* NINTH ROW */}
                <div className="mt-5">
                  <label
                    className="text-sm font-ibm-regular text-greyText"
                    htmlFor="areasOperation"
                  >
                    Products and Services
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-2 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                    {leadDetails?.productsAndServices?.map((data, index) => {
                      return (
                        <div key={index} className="col-span-1">
                          <div className="bg-white border border-authBorder rounded-lg">
                            <div className="px-3 py-2 border-b border-authBorder text-sm font-ibm-semibold text-black">
                              {data?.name}
                            </div>
                            <div className="p-3">
                              <p className="text-sm font-ibm-regular text-black">
                                {data?.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* BELONG TO LOHANA COMMUNITY */}
                <div className="mt-5 block xl:flex lg:flex items-center gap-5">
                  <p className="text-sm font-ibm-regular text-greyText">
                    Would you like to be a sponsor?
                  </p>
                  <div className="mt-1 flex items-center gap-3">
                    <div
                      className={`w-full px-5 py-2 shadow-none hover:shadow-none rounded-md font-ibm-regular text-sm  ${
                        leadDetails?.isInterestedInSponsorship
                          ? "bg-logoYellow border-logoYellow text-white"
                          : "bg-white border-greyBorder text-black"
                      } border hover:bg-opacity-80 normal-case`}
                    >
                      Yes
                    </div>

                    <div
                      className={`w-full px-5 py-2 shadow-none hover:shadow-none rounded-md font-ibm-regular text-sm  ${
                        !leadDetails?.isInterestedInSponsorship
                          ? "bg-logoYellow border-logoYellow text-white"
                          : "bg-white border-greyBorder text-black"
                      } border hover:bg-opacity-80 normal-case`}
                    >
                      No
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* STEP THREE */}
            {activeStep === 3 && (
              <div className="p-0 max-h-[65vh] overflow-auto">
                {/* HEADING */}
                <div className="pb-3">
                  <h5 className="text-xl font-ibm-bold text-black">
                    Pre-Book your stall
                  </h5>
                  <p className="mt-1 text-base font-ibm-regular text-greyText">
                    Pre-booking allows you to reserve your space in LIBF Expo
                    2026 by paying a token amount for the stall. Pre-booked
                    stall exhibitors shall be given priority on a
                    first-come-first basis for the allotment of their stall.
                  </p>
                  <p className="mt-2 text-base font-ibm-regular text-greyText">
                    Once you submit your request via this form and pay the
                    pre-booking amount, you shall receive an acknowledgement
                    email mentioning your priority number.
                  </p>

                  <div className="mt-5">
                    <h5 className="text-lg font-source-semibold text-black">
                      Pre-booking amounts
                    </h5>
                    <div className="mt-3 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
                      <div className="col-span-1">
                        <div className="h-full bg-logoYellow/10 rounded-md p-3 border border-logoYellow/20">
                          <p className="text-logoYellow text-xl font-source-bold">
                            ₹11,000
                          </p>
                          <p className="text-base font-source-regular text-black">
                            Tablespace
                          </p>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div className="h-full bg-logoYellow/10 rounded-md p-3 border border-logoYellow/20">
                          <p className="text-logoYellow text-xl font-source-bold">
                            ₹15,000
                          </p>
                          <p className="text-base font-source-regular text-black">
                            Economy Stall
                          </p>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div className="h-full bg-logoYellow/10 rounded-md p-3 border border-logoYellow/20">
                          <p className="text-logoYellow text-xl font-source-bold">
                            ₹25,000
                          </p>
                          <p className="text-base font-source-regular text-black">
                            Classic and Premium Shell Spaces
                          </p>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div className="h-full bg-logoYellow/10 rounded-md p-3 border border-logoYellow/20">
                          <p className="text-logoYellow text-xl font-source-bold">
                            ₹50,000
                          </p>
                          <p className="text-base font-source-regular text-black">
                            Classic and Premium Bare Spaces & Island
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* FORM */}
                <div
                  className={`pt-5 grid ${
                    leadDetails?.paymentStatus === "success"
                      ? "grid-cols-1 xl:grid-cols-3 lg:grid-cols-3"
                      : "grid-cols-1 xl:grid-cols-2 lg:grid-cols-2"
                  }  gap-5`}
                >
                  {/* PREFERRED STALL CATEGORY */}
                  <div className="col-span-1">
                    <div className="flex items-center justify-between">
                      <p className="text-base font-source-regular text-greyText">
                        Preferred stall category
                      </p>
                    </div>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="stallCategory"
                        id="stallCategory"
                        placeholder="Stall category"
                        value={leadDetails?.stallCategory ?? ""}
                        onChange={(e) =>
                          setLeadDetails((prev) =>
                            prev
                              ? { ...prev, stallCategory: e.target.value }
                              : prev
                          )
                        }
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* PREFERRED STALL AREA */}
                  <div className="col-span-1">
                    <div className="flex items-center justify-between">
                      <p className="text-base font-source-regular text-greyText">
                        Preferred stall area
                      </p>
                    </div>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="stallSize"
                        id="stallSize"
                        placeholder="Stall size"
                        value={leadDetails?.stallSize ?? ""}
                        onChange={(e) =>
                          setLeadDetails((prev) =>
                            prev ? { ...prev, stallSize: e.target.value } : prev
                          )
                        }
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* AMOUNT PAID */}
                  {leadDetails?.paymentStatus === "success" && (
                    <div className="col-span-1">
                      <label
                        className="block text-greyText text-sm font-ibm-regular"
                        htmlFor="amountPaid"
                      >
                        Amount paid (Pre-booking amount + GST + Gateway Fees){" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="mt-1 relative">
                        {currency === "USD" ? (
                          <input
                            type="text"
                            name="amountPaid"
                            id="amountPaid"
                            placeholder="Amount Paid"
                            disabled
                            value={`${pricing} + ${parseFloat(
                              pricing * 0.18
                            ).toFixed(0)} + ${parseFloat(
                              (pricing + parseFloat(pricing * 0.18)) * 0.0675
                            ).toFixed(0)} = ${Math.ceil(
                              pricing +
                                parseFloat(pricing * 0.18) +
                                parseFloat(
                                  (pricing + parseFloat(pricing * 0.18)) *
                                    0.0675
                                )
                            )}`}
                            className="block w-full bg-white border border-authBorder rounded-lg pr-4 pl-14 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                          />
                        ) : (
                          <input
                            type="text"
                            name="amountPaid"
                            id="amountPaid"
                            placeholder="Amount Paid"
                            disabled
                            value={`${pricing} + ${parseFloat(
                              pricing * 0.18
                            ).toFixed(0)} + ${parseFloat(
                              (pricing + parseFloat(pricing * 0.18)) * 0.023
                            ).toFixed(0)} = ${leadDetails?.payAmount}`}
                            className="block w-full bg-white border border-authBorder rounded-lg pr-4 pl-14 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                          />
                        )}

                        <div className="absolute top-[1.5vh] left-5">
                          <p className="text-[1.4vh] font-ibm-semibold text-black">
                            {currency}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div className="px-5 py-3">
            {activeStep === 1 && (
              <div className="flex items-center justify-end">
                <Button
                  onClick={() => setActiveStep(2)}
                  className="normal-case shadow-none hover:shadow-none bg-logoYellow rounded-md px-5 py-3 hover:bg-logoYellow/80 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white"
                >
                  Next: Business details
                </Button>
              </div>
            )}

            {activeStep === 2 && (
              <div className="flex items-center justify-end gap-3">
                <Button
                  onClick={() => setActiveStep(1)}
                  className="normal-case shadow-none hover:shadow-none bg-greyBg border border-authBorder rounded-md px-5 py-3 hover:bg-logoYellow/10 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-black"
                >
                  Previous: Personal Details
                </Button>
                <Button
                  onClick={() => setActiveStep(3)}
                  className="normal-case shadow-none hover:shadow-none bg-logoYellow border border-logoYellow rounded-md px-5 py-3 hover:bg-logoYellow/80 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white"
                >
                  Next: Stall Details
                </Button>
              </div>
            )}

            {activeStep === 3 && (
              <div className="flex items-center justify-end gap-3">
                <Button
                  onClick={() => setActiveStep(2)}
                  className="normal-case shadow-none hover:shadow-none bg-greyBg border border-authBorder rounded-md px-5 py-3 hover:bg-logoYellow/10 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-black"
                >
                  Previous: Business Details
                </Button>
                <Button
                  type="button"
                  onClick={editFormHandler}
                  disabled={editSaving || editLoading}
                  className="normal-case shadow-none hover:shadow-none bg-logoYellow border border-logoYellow rounded-md px-5 py-3 hover:bg-logoYellow/80 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {editSaving ? "Saving..." : "Save changes"}
                </Button>
              </div>
            )}
          </div>
        </DialogBody>
      </Dialog>

      {/* EDIT STALL SIZE/CATEGORY */}
      <Dialog
        open={editStallSizeDialog}
        handler={() => setEditStallSizeDialog(!editStallSizeDialog)}
        size="xs"
        className="outline-none"
      >
        {/* HEADING */}
        <div className="px-5 py-3 border-b border-authBorder">
          <div className="flex items-center justify-between">
            <h5 className="text-base font-ibm-semibold text-black">
              Edit stall size/stall category
            </h5>
            <Button
              onClick={() => setEditStallSizeDialog(!editStallSizeDialog)}
              className="shadow-none hover:shadow-none bg-transparent hover:bg-black/10 transition-all duration-300 ease-in-out rounded-full p-1.5"
            >
              <IoClose className="w-4 h-4 text-greyText" />
            </Button>
          </div>
        </div>

        {/* BODY */}
        <div className="p-5">
          {/* DETAILS TO BE ENTERED */}
          <div className="p-0">
            <p className="text-base font-source-regular text-greyText">
              Select the category
            </p>
            <div className="mt-1">
              <Select
                options={stallOptions}
                className="react-select"
                classNamePrefix="dropdown"
                value={updatedCategory}
                onChange={(e) => setUpdatedCategory(e)}
                placeholder="Select stall category"
              />
            </div>
          </div>

          <div className="pt-5">
            <p className="text-base font-source-regular text-greyText">
              Enter the stall area
            </p>
            <div className="mt-1">
              <input
                type="text"
                name="updatedStallSize"
                id="updatedStallSize"
                placeholder="Stall size"
                value={updatedStallSize}
                onChange={(e) => setUpdatedStallSize(e.target.value)}
                className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
              />
            </div>
          </div>

          {/* SELECTED DETAILS */}
          <div className="mt-5 p-5 bg-body rounded-xl shadow border border-authBorder">
            <h5 className="text-black font-source-bold text-lg">
              Details selected by user
            </h5>

            <div className="mt-3">
              <div className="flex items-center justify-between">
                <p className="text-base font-source-regular text-greyText">
                  Preferred stall category
                </p>
              </div>
              <div className="mt-1">
                <input
                  type="text"
                  name="areaSize"
                  id="areaSize"
                  placeholder="Stall category"
                  disabled
                  value={
                    leadDetails?.stallCategory ===
                    "Startup Pavilion (2 Sides Open)"
                      ? "Economy Stall (2 Sides Open)"
                      : leadDetails?.stallCategory ===
                        "Startup Pavilion (1 Side Open)"
                      ? "Economy Stall (1 Side Open)"
                      : leadDetails?.stallCategory
                  }
                  className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                />
              </div>
            </div>

            {/* PREFERRED STALL AREA */}
            <div className="mt-5">
              <div className="flex items-center justify-between">
                <p className="text-base font-source-regular text-greyText">
                  Preferred stall area
                </p>
              </div>
              <div className="mt-1">
                <input
                  type="text"
                  name="areaSize"
                  id="areaSize"
                  placeholder="Stall size"
                  disabled
                  value={leadDetails?.stallSize}
                  className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                />
              </div>
            </div>
          </div>
        </div>

        {/* ACTION */}
        <div className="px-5 py-2 border-t border-authBorder flex items-center justify-end">
          <Button
            onClick={updateStallCategoryFn}
            className="normal-case shadow-none hover:shadow-none bg-logoYellow border border-logoYellow rounded-md px-5 py-3 hover:bg-logoYellow/80 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white"
          >
            {stallSizeLoading
              ? "Updating stall details..."
              : "Update stall details"}
          </Button>
        </div>
      </Dialog>

      {/* VIEW DIALOG */}
      <Dialog
        open={viewDialog}
        handler={() => setViewDialog(!viewDialog)}
        size="lg"
        className="outline-none"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-authBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-base font-ibm-semibold text-black">
                {activeStep === 1 && "Personal Details"}
                {activeStep === 2 && "Business Details"}
                {activeStep === 3 && "Payment Details"}
              </h5>
              <Button
                onClick={() => {
                  setViewDialog(!viewDialog);
                  setActiveStep(1);
                }}
                className="shadow-none hover:shadow-none bg-transparent hover:bg-black/10 transition-all duration-300 ease-in-out rounded-full p-1.5"
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5 border-b border-authBorder">
            {/* STEP ONE */}
            {activeStep === 1 && (
              <div className="p-0">
                {/* FIRST ROW */}
                <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                  {/* PROFILE PHOTO */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Profile photo <span className="text-red-400">*</span>
                    </label>
                    <div className="mt-1">
                      <img
                        src={`https://storage.googleapis.com/kidsstreet-test/${leadDetails?.profileImage}`}
                        className="w-20 h-20 rounded-lg object-cover"
                        alt="Profile"
                      />
                    </div>
                  </div>

                  {/* FIRST NAME */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="firstName"
                    >
                      First name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        placeholder="First name"
                        disabled
                        value={leadDetails?.firstName}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* LAST NAME */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="lastName"
                    >
                      Last name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="lastName"
                        id="lastName"
                        placeholder="Last name"
                        disabled
                        value={leadDetails?.lastName}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* SECOND ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* GENDER */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Gender
                    </label>
                    <div className="mt-1 flex items-center gap-3">
                      {["Male", "Female", "Others"].map((data, index) => {
                        return (
                          <div
                            className={`w-full px-5 py-3 shadow-none hover:shadow-none rounded-md font-ibm-semibold text-sm text-center  ${
                              leadDetails?.gender === data
                                ? "bg-logoYellow border-logoYellow text-white"
                                : "bg-white border-greyBorder text-black"
                            } border hover:bg-opacity-80 normal-case`}
                            key={index}
                          >
                            {data}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* DATE OF BIRTH */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Date of birth <span className="text-red-400">*</span>
                    </label>
                    <div className="mt-1">
                      <DatePicker
                        selected={leadDetails?.dob}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Date of birth"
                        className="w-full text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* THIRD ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* EMAIL */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="email"
                    >
                      Email <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="email"
                        id="email"
                        placeholder="Email"
                        disabled
                        value={leadDetails?.email}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* PHONE */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="contact"
                    >
                      Phone <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="phoneNumber"
                        id="phoneNumber"
                        placeholder="Phone"
                        disabled
                        value={leadDetails?.phoneNumber}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* FOURTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
                  {/* ADDRESS */}
                  <div className="col-span-4">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="address"
                    >
                      Address <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="address"
                        id="address"
                        placeholder="Address"
                        disabled
                        value={leadDetails?.personalAddressDetails?.address}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* COUNTRY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="country"
                    >
                      Country <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="country"
                        id="country"
                        placeholder="Country"
                        disabled
                        value={leadDetails?.personalAddressDetails?.country}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* STATE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="state"
                    >
                      State <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="state"
                        id="state"
                        placeholder="State"
                        disabled
                        value={leadDetails?.personalAddressDetails?.state}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* CITY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="state"
                    >
                      City <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="city"
                        id="city"
                        placeholder="City"
                        disabled
                        value={leadDetails?.personalAddressDetails?.city}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* POSTAL CODE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="postalCode"
                    >
                      Postal code <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="postalCode"
                        id="postalCode"
                        placeholder="Postal code"
                        disabled
                        value={leadDetails?.personalAddressDetails?.postalCode}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* FIFTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* EDUCATIONAL QUALIFICATIONS */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="education"
                    >
                      Educational Qualifications{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="educationQualification"
                        id="educationQualification"
                        placeholder="Education Qualification"
                        disabled
                        value={leadDetails?.educationQualification}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* OCCUPATION */}
                  <div className="-mt-1 col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="occupation"
                    >
                      Occupation <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="occupation"
                        id="occupation"
                        placeholder="Occupation"
                        disabled
                        value={leadDetails?.occupation}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* BELONG TO LOHANA COMMUNITY */}
                <div className="mt-5 block xl:flex lg:flex items-center gap-5">
                  <p className="text-sm font-ibm-regular text-greyText">
                    Do you belong to the Lohana community?
                  </p>
                  <div className="mt-1 flex items-center gap-3">
                    <div
                      className={`w-full px-5 py-2 shadow-none hover:shadow-none rounded-md font-ibm-semibold text-sm  ${
                        leadDetails?.belongToLohana === true
                          ? "bg-logoYellow border-logoYellow text-white"
                          : "bg-white border-greyBorder text-black"
                      } border hover:bg-opacity-80 normal-case`}
                    >
                      Yes
                    </div>
                    <div
                      className={`w-full px-5 py-2 shadow-none hover:shadow-none rounded-md font-ibm-semibold text-sm  ${
                        leadDetails?.belongToLohana === false
                          ? "bg-logoYellow border-logoYellow text-white"
                          : "bg-white border-greyBorder text-black"
                      } border hover:bg-opacity-80 normal-case`}
                    >
                      No
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* STEP TWO */}
            {activeStep === 2 && (
              <div className="p-0 max-h-[65vh] overflow-auto">
                {/* FIRST ROW */}
                <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                  {/* BUSINESS LOGO */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Business Logo <span className="text-red-400">*</span>
                    </label>
                    <div className="mt-1">
                      <img
                        src={`https://storage.googleapis.com/kidsstreet-test/${leadDetails?.businessLogo}`}
                        className="w-20 h-20 rounded-lg object-cover"
                        alt="Business logo"
                      />
                    </div>
                  </div>

                  {/* BUSINESS NAME */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="businessName"
                    >
                      Business name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessName"
                        id="businessName"
                        placeholder="Business name"
                        disabled
                        value={leadDetails?.businessName}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* BILLING NAME */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="billingName"
                    >
                      Billing name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingName"
                        id="billingName"
                        placeholder="Billing name"
                        disabled
                        value={leadDetails?.billingName}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* SECOND ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                  {/* BUSINESS EMAIL ADDRESS */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="businessEmail"
                    >
                      Business email address{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessName"
                        id="businessName"
                        placeholder="Business name"
                        disabled
                        value={leadDetails?.businessEmail}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* BUSINESS PHONE */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="businessPhone"
                    >
                      Business phone number{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessPhoneNumber"
                        id="businessPhoneNumber"
                        placeholder="Business phone number"
                        disabled
                        value={leadDetails?.businessPhoneNumber}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* WEBSITE URL */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="website"
                    >
                      Website URL
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="website"
                        id="website"
                        placeholder="Website URL"
                        disabled
                        value={leadDetails?.websiteUrl}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* THIRD ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
                  {/* ADDRESS */}
                  <div className="col-span-4">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="businessAddress"
                    >
                      Address <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="address"
                        id="address"
                        placeholder="Business name"
                        disabled
                        value={leadDetails?.businessAddressDetails?.address}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* COUNTRY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="businessCountry"
                    >
                      Country <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="country"
                        id="country"
                        placeholder="Country"
                        disabled
                        value={leadDetails?.businessAddressDetails?.country}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* STATE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="businessState"
                    >
                      State <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessState"
                        id="businessState"
                        placeholder="Business state"
                        disabled
                        value={leadDetails?.businessAddressDetails?.state}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* CITY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="businessCity"
                    >
                      City <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessCity"
                        id="businessCity"
                        placeholder="Business city"
                        disabled
                        value={leadDetails?.businessAddressDetails?.city}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* POSTAL CODE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="businessPostalCode"
                    >
                      Postal code <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="businessPostalCode"
                        id="businessPostalCode"
                        placeholder="Business postal code"
                        disabled
                        value={leadDetails?.businessAddressDetails?.postalCode}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* FOURTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
                  {/* ADDRESS */}
                  <div className="col-span-4">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="billingAddress"
                    >
                      Billing address <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingAddress"
                        id="billingAddress"
                        placeholder="Billing address"
                        disabled
                        value={leadDetails?.billingAddressDetails?.address}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* COUNTRY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="billingCountry"
                    >
                      Country <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingCountry"
                        id="billingCountry"
                        placeholder="Billing country"
                        disabled
                        value={leadDetails?.billingAddressDetails?.country}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* STATE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="billingState"
                    >
                      State <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingState"
                        id="billingState"
                        placeholder="Billing state"
                        disabled
                        value={leadDetails?.billingAddressDetails?.state}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* CITY */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="billingCity"
                    >
                      City <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingCity"
                        id="billingCity"
                        placeholder="Billing city"
                        disabled
                        value={leadDetails?.billingAddressDetails?.city}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* POSTAL CODE */}
                  <div className="col-span-4 xl:col-span-1 lg:col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="billingPostalCode"
                    >
                      Postal code <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="billingPostalCode"
                        id="billingPostalCode"
                        placeholder="Billing postal code"
                        disabled
                        value={leadDetails?.billingAddressDetails?.postalCode}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* FIFTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* GST NUMBER */}
                  <div className="col-span-1">
                    <label
                      className="block text-greyText text-sm font-ibm-regular"
                      htmlFor="gstNumber"
                    >
                      GST Number <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="gstNumber"
                        id="gstNumber"
                        placeholder="GST Number"
                        disabled
                        value={leadDetails?.gstNumber ?? "-"}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* PAN NUMBER */}
                  <div className="col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="panNumber"
                    >
                      PAN Number <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="panNumber"
                        id="panNumber"
                        placeholder="PAN Number"
                        disabled
                        value={leadDetails?.panNumber ?? "-"}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>
                </div>

                {/* SIXTH ROW */}
                <div className="mt-5">
                  <label
                    className="block text-greyText text-sm font-ibm-regular"
                    htmlFor="industry"
                  >
                    Industry / Sectors <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-2 flex items-center gap-2 flex-wrap">
                    {leadDetails?.industry?.map((data, index) => {
                      return (
                        <div
                          className="bg-logoYellow/5 border border-logoYellow rounded-md px-4 py-2 text-sm font-ibm-semibold text-logoYellow"
                          key={index}
                        >
                          {data}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* SEVENTH ROW */}
                <div className="mt-5">
                  {/* BRIEF INTRODUCTION */}
                  <label
                    className="block text-greyText text-sm font-ibm-regular"
                    htmlFor="briefIntroduction"
                  >
                    Give a brief introduction about your business{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-2">
                    <textarea
                      rows="2"
                      disabled
                      name="briefIntroduction"
                      id="briefIntroduction"
                      placeholder="Give a brief introduction about your business"
                      value={leadDetails?.briefBusinessDescription}
                      className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                    />
                  </div>
                </div>

                {/* EIGTH ROW */}
                <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                  {/* AREAS OF OPERATION */}
                  <div className="col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="areasOperation"
                    >
                      Geographical areas of operation{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-2 flex items-center gap-2 flex-wrap">
                      {leadDetails?.areasOfOperation?.map((data, index) => {
                        return (
                          <div
                            className="bg-logoYellow/5 border border-logoYellow rounded-md px-4 py-2 text-sm font-ibm-semibold text-logoYellow"
                            key={index}
                          >
                            {data}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* AREAS OF OPERATION WISHING TO EXPLORE */}
                  <div className="col-span-1">
                    <label
                      className="text-sm font-ibm-regular text-greyText"
                      htmlFor="areasWishing"
                    >
                      Geographical areas wishing to explore{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-2 flex items-center gap-2 flex-wrap">
                      {leadDetails?.areasOfExploration?.map((data, index) => {
                        return (
                          <div
                            className="bg-logoYellow/5 border border-logoYellow rounded-md px-4 py-2 text-sm font-ibm-semibold text-logoYellow"
                            key={index}
                          >
                            {data}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* NINTH ROW */}
                <div className="mt-5">
                  <label
                    className="text-sm font-ibm-regular text-greyText"
                    htmlFor="areasOperation"
                  >
                    Products and Services
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-2 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                    {leadDetails?.productsAndServices?.map((data, index) => {
                      return (
                        <div key={index} className="col-span-1">
                          <div className="bg-white border border-authBorder rounded-lg">
                            <div className="px-3 py-2 border-b border-authBorder text-sm font-ibm-semibold text-black">
                              {data?.name}
                            </div>
                            <div className="p-3">
                              <p className="text-sm font-ibm-regular text-black">
                                {data?.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* BELONG TO LOHANA COMMUNITY */}
                <div className="mt-5 block xl:flex lg:flex items-center gap-5">
                  <p className="text-sm font-ibm-regular text-greyText">
                    Would you like to be a sponsor?
                  </p>
                  <div className="mt-1 flex items-center gap-3">
                    <div
                      className={`w-full px-5 py-2 shadow-none hover:shadow-none rounded-md font-ibm-regular text-sm  ${
                        leadDetails?.isInterestedInSponsorship
                          ? "bg-logoYellow border-logoYellow text-white"
                          : "bg-white border-greyBorder text-black"
                      } border hover:bg-opacity-80 normal-case`}
                    >
                      Yes
                    </div>

                    <div
                      className={`w-full px-5 py-2 shadow-none hover:shadow-none rounded-md font-ibm-regular text-sm  ${
                        !leadDetails?.isInterestedInSponsorship
                          ? "bg-logoYellow border-logoYellow text-white"
                          : "bg-white border-greyBorder text-black"
                      } border hover:bg-opacity-80 normal-case`}
                    >
                      No
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* STEP THREE */}
            {activeStep === 3 && (
              <div className="p-0 max-h-[65vh] overflow-auto">
                {/* HEADING */}
                <div className="pb-3">
                  <h5 className="text-xl font-ibm-bold text-black">
                    Pre-Book your stall
                  </h5>
                  <p className="mt-1 text-base font-ibm-regular text-greyText">
                    Pre-booking allows you to reserve your space in LIBF Expo
                    2026 by paying a token amount for the stall. Pre-booked
                    stall exhibitors shall be given priority on a
                    first-come-first basis for the allotment of their stall.
                  </p>
                  <p className="mt-2 text-base font-ibm-regular text-greyText">
                    Once you submit your request via this form and pay the
                    pre-booking amount, you shall receive an acknowledgement
                    email mentioning your priority number.
                  </p>

                  <div className="mt-5">
                    <h5 className="text-lg font-source-semibold text-black">
                      Pre-booking amounts
                    </h5>
                    <div className="mt-3 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
                      <div className="col-span-1">
                        <div className="h-full bg-logoYellow/10 rounded-md p-3 border border-logoYellow/20">
                          <p className="text-logoYellow text-xl font-source-bold">
                            ₹11,000
                          </p>
                          <p className="text-base font-source-regular text-black">
                            Tablespace
                          </p>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div className="h-full bg-logoYellow/10 rounded-md p-3 border border-logoYellow/20">
                          <p className="text-logoYellow text-xl font-source-bold">
                            ₹15,000
                          </p>
                          <p className="text-base font-source-regular text-black">
                            Economy Stall
                          </p>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div className="h-full bg-logoYellow/10 rounded-md p-3 border border-logoYellow/20">
                          <p className="text-logoYellow text-xl font-source-bold">
                            ₹25,000
                          </p>
                          <p className="text-base font-source-regular text-black">
                            Classic and Premium Shell Spaces
                          </p>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div className="h-full bg-logoYellow/10 rounded-md p-3 border border-logoYellow/20">
                          <p className="text-logoYellow text-xl font-source-bold">
                            ₹50,000
                          </p>
                          <p className="text-base font-source-regular text-black">
                            Classic and Premium Bare Spaces & Island
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {leadDetails?.paymentScreenshot && (
                    <div className="mt-5">
                      <p className="text-base font-source-regular text-greyText">
                        Payment screenshot
                      </p>
                      <div className="mt-1">
                        <img
                          src={`https://storage.googleapis.com/kidsstreet-test/${leadDetails?.paymentScreenshot}`}
                          className="w-1/3 rounded-lg object-cover"
                          alt="Payment screenshot"
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* FORM */}
                <div
                  className={`pt-5 grid ${
                    leadDetails?.paymentStatus === "success"
                      ? "grid-cols-1 xl:grid-cols-3 lg:grid-cols-3"
                      : "grid-cols-1 xl:grid-cols-2 lg:grid-cols-2"
                  }  gap-5`}
                >
                  {/* PREFERRED STALL CATEGORY */}
                  <div className="col-span-1">
                    <div className="flex items-center justify-between">
                      <p className="text-base font-source-regular text-greyText">
                        Preferred stall category
                      </p>
                    </div>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="areaSize"
                        id="areaSize"
                        placeholder="Stall category"
                        disabled
                        value={
                          leadDetails?.stallCategory ===
                          "Startup Pavilion (2 Sides Open)"
                            ? "Economy Stall (2 Sides Open)"
                            : leadDetails?.stallCategory ===
                              "Startup Pavilion (1 Side Open)"
                            ? "Economy Stall (1 Side Open)"
                            : leadDetails?.stallCategory
                        }
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* PREFERRED STALL AREA */}
                  <div className="col-span-1">
                    <div className="flex items-center justify-between">
                      <p className="text-base font-source-regular text-greyText">
                        Preferred stall area
                      </p>
                    </div>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="areaSize"
                        id="areaSize"
                        placeholder="Stall size"
                        disabled
                        value={leadDetails?.stallSize}
                        className="block w-full bg-white border border-authBorder rounded-lg px-4 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                      />
                    </div>
                  </div>

                  {/* AMOUNT PAID */}
                  {leadDetails?.paymentStatus === "success" && (
                    <div className="col-span-1">
                      <label
                        className="block text-greyText text-sm font-ibm-regular"
                        htmlFor="amountPaid"
                      >
                        Amount paid (Pre-booking amount + GST + Gateway Fees){" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="mt-1 relative">
                        {currency === "USD" ? (
                          <input
                            type="text"
                            name="amountPaid"
                            id="amountPaid"
                            placeholder="Amount Paid"
                            disabled
                            value={`${pricing} + ${parseFloat(
                              pricing * 0.18
                            ).toFixed(0)} + ${parseFloat(
                              (pricing + parseFloat(pricing * 0.18)) * 0.0675
                            ).toFixed(0)} = ${Math.ceil(
                              pricing +
                                parseFloat(pricing * 0.18) +
                                parseFloat(
                                  (pricing + parseFloat(pricing * 0.18)) *
                                    0.0675
                                )
                            )}`}
                            className="block w-full bg-white border border-authBorder rounded-lg pr-4 pl-14 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                          />
                        ) : (
                          <input
                            type="text"
                            name="amountPaid"
                            id="amountPaid"
                            placeholder="Amount Paid"
                            disabled
                            value={`${pricing} + ${parseFloat(
                              pricing * 0.18
                            ).toFixed(0)} + ${parseFloat(
                              (pricing + parseFloat(pricing * 0.18)) * 0.023
                            ).toFixed(0)} = ${leadDetails?.payAmount}`}
                            className="block w-full bg-white border border-authBorder rounded-lg pr-4 pl-14 py-3 font-ibm-semibold text-sm placeholder:text-sm placeholder:font-ibm-regular text-black"
                          />
                        )}

                        <div className="absolute top-[1.5vh] left-5">
                          <p className="text-[1.4vh] font-ibm-semibold text-black">
                            {currency}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div
            className={`px-5 py-3 flex items-center ${
              activeStep === 3 ? "justify-between" : "justify-end"
            }`}
          >
            {activeStep === 3 && (
              <div className="bg-logoYellow/5 border border-logoYellow/50 rounded-lg px-4 py-2 flex items-center gap-4">
                <div className="p-0">
                  <p className="text-sm font-ibm-regular text-greyText">
                    Booking amount
                  </p>
                  <p className="text-sm font-ibm-semibold text-black">
                    {leadDetails?.currency} {leadDetails?.pricing}
                  </p>
                </div>
                <p className="text-sm font-ibm-regular text-greyText">+</p>
                <div className="p-0">
                  <p className="text-sm font-ibm-regular text-greyText">GST</p>
                  <p className="text-sm font-ibm-semibold text-black">
                    {leadDetails?.currency}{" "}
                    {
                      leadDetails?.paymentSummary?.find(
                        (item) => item.type === "GST"
                      )?.price
                    }
                  </p>
                </div>
                <p className="text-sm font-ibm-regular text-greyText">+</p>
                <div className="p-0">
                  <p className="text-sm font-ibm-regular text-greyText">
                    Gateway Fee
                  </p>
                  <p className="text-sm font-ibm-semibold text-black">
                    {leadDetails?.currency}{" "}
                    {
                      leadDetails?.paymentSummary?.find(
                        (item) => item.type === "GATEWAY_FEE"
                      )?.price
                    }
                  </p>
                </div>
                <p className="text-sm font-ibm-regular text-greyText">=</p>
                <div className="p-0">
                  <p className="text-sm font-ibm-regular text-greyText">
                    Payable amount
                  </p>
                  <p className="text-sm font-ibm-semibold text-black">
                    {leadDetails?.currency} {leadDetails?.payAmount}
                  </p>
                </div>
              </div>
            )}

            <div className="p-0">
              {activeStep === 1 && (
                <div className="flex items-center justify-end">
                  <Button
                    onClick={() => setActiveStep(2)}
                    className="normal-case shadow-none hover:shadow-none bg-logoYellow rounded-md px-5 py-3 hover:bg-logoYellow/80 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white"
                  >
                    Next: Business details
                  </Button>
                </div>
              )}

              {activeStep === 2 && (
                <div className="flex items-center justify-end gap-3">
                  <Button
                    onClick={() => setActiveStep(1)}
                    className="normal-case shadow-none hover:shadow-none bg-greyBg border border-authBorder rounded-md px-5 py-3 hover:bg-logoYellow/10 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-black"
                  >
                    Previous: Personal Details
                  </Button>
                  <Button
                    onClick={() => setActiveStep(3)}
                    className="normal-case shadow-none hover:shadow-none bg-logoYellow border border-logoYellow rounded-md px-5 py-3 hover:bg-logoYellow/80 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white"
                  >
                    Next: Stall Details
                  </Button>
                </div>
              )}

              {activeStep === 3 && (
                <div className="flex items-center justify-end gap-3">
                  <Button
                    onClick={() => setActiveStep(2)}
                    className="normal-case shadow-none hover:shadow-none bg-greyBg border border-authBorder rounded-md px-5 py-3 hover:bg-logoYellow/10 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-black"
                  >
                    Previous: Business Details
                  </Button>
                </div>
              )}
            </div>
          </div>
        </DialogBody>
      </Dialog>

      {/* UPDATE STATUS */}
      <Dialog
        open={statusDialog}
        handler={() => setStatusDialog(!statusDialog)}
        size="sm"
        className="outline-none"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-authBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-base font-ibm-semibold text-black">
                Payment Status
              </h5>
              <Button
                onClick={() => {
                  setStatusDialog(!statusDialog);
                  setPaymentRemark("");
                  setCurrencyAmount(null);
                  setSelectedCurrency(null);
                  setTransactionId("");
                }}
                className="shadow-none hover:shadow-none bg-transparent hover:bg-black/10 transition-all duration-300 ease-in-out rounded-full p-1.5"
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5">
            {/* PAYMENT STATUS */}
            <div className="p-0">
              <label className="text-sm font-ibm-regular text-greyText">
                Status
              </label>
              <div className="mt-1">
                <Select
                  options={[
                    { label: "Unpaid", value: "pending" },
                    {
                      label: "Pre-booking amount paid",
                      value: "Pre-booking amount paid",
                    },
                    {
                      label: "Balance amount paid",
                      value: "Balance amount paid",
                    },
                    {
                      label: "Full amount paid",
                      value: "Full amount paid",
                    },
                  ]}
                  className="react-select font-proxima-regular"
                  classNamePrefix="dropdown"
                  placeholder="Select status"
                  name="paymentStatus"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e)}
                />
              </div>
            </div>

            {selectedStatus !== null && (
              <React.Fragment>
                <div className="pt-5 grid grid-cols-1 md:grid-cols-2 gap-5">
                  {/* TRANSACTION ID */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Transaction ID/UTR no./Cheque No.
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="transactionId"
                        value={transactionId}
                        onChange={(e) => setTransactionId(e.target.value)}
                        placeholder="Transaction ID/UTR no./Cheque No."
                        className="block w-full px-5 py-3 rounded-md border border-authBorder text-sm font-ibm-regular text-black placeholder:text-sm placeholder:text-gray-500 placeholder:font-ibm-regular focus:outline-logoYellow"
                      />
                    </div>
                  </div>

                  {/* TRANSACTION DATE */}
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Transaction date
                    </label>
                    <div className="mt-1">
                      <input
                        type="date"
                        name="transactionDate"
                        value={transactionDate}
                        onChange={(e) => setTransactionDate(e.target.value)}
                        placeholder="Transaction Date"
                        className="block w-full px-5 py-3 rounded-md border border-authBorder text-sm font-ibm-regular text-black placeholder:text-sm placeholder:text-gray-500 placeholder:font-ibm-regular focus:outline-logoYellow"
                      />
                    </div>
                  </div>
                </div>

                {/* CURRENCY AND AMOUNT */}
                <div className="pt-5 grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Currency
                    </label>
                    <div className="mt-1">
                      <Select
                        options={[
                          { label: "INR", value: "INR" },
                          { value: "USD", label: "USD" },
                        ]}
                        classNamePrefix="dropdown"
                        name="selectedCurrency"
                        value={selectedCurrency}
                        onChange={(e) => setSelectedCurrency(e)}
                        placeholder="Select currency"
                      />
                    </div>
                  </div>
                  <div className="col-span-1">
                    <label className="text-sm font-ibm-regular text-greyText">
                      Amount
                    </label>
                    <div className="mt-1">
                      <input
                        type="number"
                        name="currencyAmount"
                        value={currencyAmount}
                        onChange={(e) => setCurrencyAmount(e.target.value)}
                        placeholder="Enter currency amount"
                        className="block w-full px-5 py-3 rounded-md border border-authBorder text-sm font-ibm-regular text-black placeholder:text-sm placeholder:text-gray-500 placeholder:font-ibm-regular focus:outline-logoYellow"
                      />
                    </div>
                  </div>
                </div>

                {/* PAYMENT REMARK */}
                <div className="pt-5">
                  <label className="text-sm font-ibm-regular text-greyText">
                    Payment remark
                  </label>
                  <div className="mt-1">
                    <textarea
                      rows="2"
                      name="paymentRemark"
                      value={paymentRemark}
                      onChange={(e) => setPaymentRemark(e.target.value)}
                      placeholder="Write the payment remark (if any)"
                      className="block w-full px-5 py-3 rounded-md border border-authBorder text-sm font-ibm-regular text-black placeholder:text-sm placeholder:text-gray-500 placeholder:font-ibm-regular focus:outline-logoYellow"
                    />
                  </div>
                </div>

                {/* PAYMENT SCREENSHOT */}
                <div className="pt-5">
                  <label className="text-sm font-ibm-regular text-greyText">
                    Payment screenshot
                  </label>
                  <div className="mt-1">
                    <ReactImageUploading
                      value={paymentScreenshot}
                      onChange={setPaymentScreenshot}
                      maxNumber={1}
                      dataURLKey="data_url"
                    >
                      {({ imageList, onImageUpload, onImageRemove }) => (
                        <div className="flex items-center gap-5">
                          {/* UPLOAD IMAGE */}
                          <div
                            onClick={onImageUpload}
                            className="w-24 h-24 flex-shrink-0 cursor-pointer bg-greyBg hover:bg-logoYellow/10 hover:border-logoYellow/50 transition-all duration-300 ease-in-out border border-authBorder flex items-center justify-center rounded-lg"
                          >
                            <div className="p-0">
                              <FiUpload className="w-5 h-5 mx-auto text-greyText" />
                              <div className="pt-3">
                                <h5 className="text-sm font-ibm-regular text-greyText text-center leading-tight">
                                  Upload from computer
                                </h5>
                              </div>
                            </div>
                          </div>

                          {imageList.map((image, index) => (
                            <div key={index} className="relative">
                              <img
                                src={image["data_url"]}
                                alt=""
                                className="w-24 h-24 flex-shrink-0 rounded-lg"
                              />

                              <div className="absolute top-0 right-0">
                                <Button
                                  onClick={onImageRemove}
                                  className="bg-white border border-authBorder p-1.5 rounded-full"
                                >
                                  <FaTrash className="w-3 h-3 text-red-400" />
                                </Button>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </ReactImageUploading>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>

          {/* ACTION */}
          <div className="px-5 py-2 border-t border-authBorder flex items-center justify-end">
            <Button
              onClick={updateStatusAPI}
              className="normal-case shadow-none hover:shadow-none bg-logoYellow border border-logoYellow rounded-md px-5 py-3 hover:bg-logoYellow/80 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white"
            >
              {statusLoading ? "Updating status..." : "Update status"}
            </Button>
          </div>
        </DialogBody>
      </Dialog>

      {/* UPDATE PRE BOOKING ID */}
      <Dialog
        open={invoiceDialog}
        handler={() => setInvoiceDialog(!invoiceDialog)}
        size="xs"
        className="outline-none"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-authBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-base font-ibm-semibold text-black">
                Edit Booking ID/Invoice ID
              </h5>
              <Button
                onClick={() => {
                  setInvoiceDialog(!invoiceDialog);
                  setSelectedInvoiceId();
                }}
                className="shadow-none hover:shadow-none bg-transparent hover:bg-black/10 transition-all duration-300 ease-in-out rounded-full p-1.5"
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5">
            <label className="text-sm font-ibm-regular text-greyText">
              Booking ID/Invoice ID
            </label>
            <div className="mt-1">
              <input
                type="text"
                name="invoiceId"
                value={selectedInvoiceId}
                onChange={(e) => setSelectedInvoiceId(e.target.value)}
                placeholder="Enter the Booking ID/Invoice ID"
                className="block w-full px-5 py-3 rounded-md border border-authBorder text-sm font-ibm-regular text-black placeholder:text-sm placeholder:text-gray-500 placeholder:font-ibm-regular focus:outline-logoYellow"
              />
            </div>
          </div>

          {/* ACTION */}
          <div className="px-5 py-2 border-t border-authBorder flex items-center justify-end">
            <Button
              onClick={updateBookingId}
              className="normal-case shadow-none hover:shadow-none bg-logoYellow border border-logoYellow rounded-md px-5 py-3 hover:bg-logoYellow/80 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white"
            >
              {invoiceLoading ? "Updating ID..." : "Update ID"}
            </Button>
          </div>
        </DialogBody>
      </Dialog>

      {/* VIEW PAYMENT STATUS */}
      <Dialog
        open={paymentStatusDialog}
        handler={() => setPaymentStatusDialog(!paymentStatusDialog)}
        size="xs"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-authBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-base font-ibm-semibold text-black">
                View payment status
              </h5>
              <Button
                onClick={() => {
                  setPaymentStatusDialog(!paymentStatusDialog);
                }}
                className="shadow-none hover:shadow-none bg-transparent hover:bg-black/10 transition-all duration-300 ease-in-out rounded-full p-1.5"
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5">
            <div className="p-0">
              <label className="text-sm font-source-regular text-greyText">
                Payment Status
              </label>
              <p className="text-base font-source-semibold text-black">
                {leadDetails?.paymentStatus}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5">
              <div className="col-span-1">
                <label className="text-sm font-source-regular text-greyText">
                  Transaction ID
                </label>
                <p className="text-base font-source-semibold text-black">
                  {leadDetails?.transactionId}
                </p>
              </div>

              <div className="col-span-1">
                <label className="text-sm font-source-regular text-greyText">
                  Transaction date
                </label>
                <p className="text-base font-source-semibold text-black">
                  {leadDetails?.transactionDate ?? "-"}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5">
              <div className="col-span-1">
                <label className="text-sm font-source-regular text-greyText">
                  Currency
                </label>
                <p className="text-base font-source-semibold text-black">
                  {leadDetails?.remarkCurrency}
                </p>
              </div>
              <div className="col-span-1">
                <label className="text-sm font-source-regular text-greyText">
                  Amount
                </label>
                <p className="text-base font-source-semibold text-black">
                  {leadDetails?.remarkAmount}
                </p>
              </div>
            </div>

            {leadDetails?.paymentRemark && (
              <div className="pt-5">
                <label className="text-sm font-source-regular text-greyText">
                  Payment remark
                </label>
                <p className="text-base font-source-semibold text-black">
                  {leadDetails?.paymentRemark}
                </p>
              </div>
            )}

            {leadDetails?.remarkImage && (
              <div className="pt-5">
                <label className="text-sm font-source-regular text-greyText">
                  Remark screenshot
                </label>
                <div className="mt-1">
                  <a
                    href={`${IMAGE_URL}${leadDetails?.remarkImage}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${IMAGE_URL}${leadDetails?.remarkImage}`}
                      alt="Remark screenshot"
                      className="w-full h-auto object-contain rounded-lg cursor-pointer"
                    />
                  </a>
                </div>
              </div>
            )}
          </div>
        </DialogBody>
      </Dialog>

      {/* DELETE DIALOG */}
      <Dialog
        open={deleteDialog}
        handler={() => setDeleteDialog(!deleteDialog)}
        size="xs"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-authBorder flex items-center justify-between">
            <h5 className="text-base font-ibm-semibold text-black">
              Confirmation
            </h5>
            <Button
              onClick={() => setDeleteDialog(!deleteDialog)}
              className="shadow-none hover:shadow-none bg-white hover:bg-black/10 rounded-full p-2 transition-all duration-300 ease-in-out"
            >
              <IoClose className="w-5 h-5 text-greyText" />
            </Button>
          </div>

          {/* BODY */}
          <div className="p-5">
            <p className="text-base font-ibm-regular text-greyText">
              Are you sure you want to delete this lead?
            </p>
          </div>

          {/* ACTIONS */}
          <div className="px-5 py-3 border-t border-authBorder flex items-center justify-end">
            <Button
              onClick={deleteFormAPI}
              className="shadow-none hover:shadow-none bg-logoYellow hover:bg-logoYellow/80 rounded-md px-5 py-3 transition-all duration-300 ease-in-out text-sm font-ibm-semibold text-white"
            >
              {deleteLoading ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </DialogBody>
      </Dialog>
    </section>
  );
};

export default PrebookingLeads;
